import { apiClient } from "@/modules/shared/utils/apiClient";

import { BookNewSessionData } from "../types/BookNewSessionData";

export type GetJoinStateResponse = {
  state: string;
  secondsUntilStart: number;
  meetingUrl: string | null;
  secondsSinceStartTime: number | null;
  rescheduleUuid: string | null;
  bookNewSession: BookNewSessionData | null;
  correlationId?: string;
};

export const getJoinState = (code: string) => {
  const params = new URLSearchParams({ accessCode: code }).toString();

  return apiClient.get<GetJoinStateResponse>(
    `/coaching-session/join/state?${params}`,
  );
};
